const hasSearchSessionContext = ({
  hasGlobalSearched,
  isSearching,
  currentSearchId,
  messages,
}) =>
  Boolean(hasGlobalSearched) ||
  Boolean(isSearching) ||
  Boolean(currentSearchId) ||
  messages.some((message) => message.type !== "system");

export function getSearchDockVisibility({
  isHistoryView,
  hasGlobalSearched,
  isSearching,
  currentSearchId,
  messages,
}) {
  if (isHistoryView) {
    return {
      showInitialSearchDock: false,
      showPersistentSearchDock: false,
    };
  }

  const hasSessionContext = hasSearchSessionContext({
    hasGlobalSearched,
    isSearching,
    currentSearchId,
    messages,
  });

  return {
    showInitialSearchDock: !hasSessionContext,
    showPersistentSearchDock: hasSessionContext,
  };
}
